//requires debounce.js

//from: https://www.lullabot.com/articles/importing-css-breakpoints-into-javascript

window.themeJs = window.themeJs || {};


themeJs.breakpoint = {};

themeJs.breakpoint.refreshValue = function () {

    themeJs.breakpoint.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};



document.addEventListener("DOMContentLoaded", function() {

    var debouncedBreakpoint = new themeJs.Debouncer(themeJs.breakpoint.refreshValue);

    themeJs.breakpoint.refreshValue();
    window.addEventListener('resize', debouncedBreakpoint.handleEvent.bind(debouncedBreakpoint));

});
